const doc = [({"en":({"js":({"admin":({"subscriptions":({"show":({"show_subscription":"Show subscription %{id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;